import {
  createCrudActions,
  createCrudActionTypes,
  createCrudMutation,
  createCrudState
} from 'vuex-module-generator';

import { chain, omit, find } from 'lodash';
import { fetchSkus } from '@/shared/apis';
import { fetchSkuAvailability } from './api';

export const types = {
  ...createCrudActionTypes('SKU_AVAILABILITY')
};

export const SkuAvailabilityState = () => (
  {
    list: createCrudState().list,
    allSkuList: [],
    projectID: '',
    exportedCategoryTabData: [],
    exportedProducerTabData: []
  }
);

// Functions for create Export data
function subTabMethods(data, parentCategoryKey, payloadExportData) {
  return chain(data).map((rootItem) => {
    if (rootItem.key === parentCategoryKey) {
      return {
        ...rootItem,
        subItems: [...payloadExportData]
      };
    }

    return { ...rootItem };
  }).value();
}
function lastTabMethods(exportData, parentCategoryKey, subCategoryKey, payloadExportData) {
  return chain(exportData)
    .map((rootItem) => {
      if (rootItem.key === parentCategoryKey) {
        const subItemsWithSku = chain(rootItem.subItems).map((subItem) => {
          if (subItem.key === subCategoryKey) {
            const skuList = chain(payloadExportData)
              .filter(data => data.sku !== undefined)
              .map((lastItem) => {
                const keyRemovedItem = omit(lastItem, ['key']);

                return {
                  key: lastItem.sku.display_name,
                  ...keyRemovedItem
                };
              }).map(sku => omit(sku, ['sku']))
              .value();

            return {
              ...subItem,
              skuList: [...skuList]
            };
          }

          return {
            ...subItem
          };
        }).value();

        const newRootItem = omit(rootItem, ['subItems']);

        return {
          ...newRootItem,
          subItems: [...subItemsWithSku]
        };
      }

      return { ...rootItem };
    }).value();
}
// Update root export data
function updateRootData(exportData, newRootExportData) {
  return chain(exportData).map((rootItem) => {
    const newRootItem = find(newRootExportData, item => rootItem.key === item.key);
    if (rootItem.key === newRootItem.key && rootItem.subItems) {
      return {
        ...newRootItem,
        subItems: [...rootItem.subItems]
      };
    }

    if (rootItem.key === newRootItem.key && !rootItem.subItems) {
      return {
        ...newRootItem
      };
    }

    return {};
  }).value();
}
// Functions for reset Export data
function resetSubTab(data, parentCategoryKey) {
  return chain(data).map((rootItem) => {
    if (rootItem.key === parentCategoryKey) {
      const newRootItem = omit(rootItem, ['subItems']);

      return {
        ...newRootItem,
        subItems: []
      };
    }

    return { ...rootItem };
  }).value();
}
function resetLastTab(exportData, parentCategoryKey, subCategoryKey) {
  return chain(exportData).map((rootItem) => {
    if (rootItem.key === parentCategoryKey) {
      const subItemsWithSku = chain(rootItem.subItems).map((subItem) => {
        if (subItem.key === subCategoryKey) {
          const newSubItem = omit(subItem, ['skuList']);

          return {
            ...newSubItem,
            skuList: []
          };
        }

        return {
          ...subItem
        };
      }).value();

      const newRootItem = omit(rootItem, ['subItems']);

      return {
        ...newRootItem,
        subItems: [...subItemsWithSku]
      };
    }

    return { ...rootItem };
  }).value();
}

export const mutations = {
  ...createCrudMutation(types),
  updateSkuListTab(state, value) {
    state.allSkuList.push(...value.allSkus);
    state.projectID = value.projectId;
  },
  updateExportedData(state, payload) {
    switch (payload.position) {
      case 'root':
        if (payload.listName === 'Category') {
          state.exportedCategoryTabData = payload.exportData;
        } else if (payload.listName === 'Producer' || payload.listName === 'Brand') {
          state.exportedProducerTabData = payload.exportData;
        }
        break;
      case 'subTab':
        if (payload.listName === 'Category') {
          const { exportedCategoryTabData } = state;

          state.exportedCategoryTabData = subTabMethods(
            exportedCategoryTabData,
            payload.exportData[0].parent_Category,
            payload.exportData
          );
        } else if (payload.listName === 'Producer' || payload.listName === 'Brand') {
          const { exportedProducerTabData } = state;

          state.exportedProducerTabData = subTabMethods(
            exportedProducerTabData,
            payload.exportData[0].parent_Producer,
            payload.exportData
          );
        }
        break;
      case 'lastTab':
        if (payload.listName === 'Category') {
          const { exportedCategoryTabData } = state;
          state.exportedCategoryTabData = lastTabMethods(
            exportedCategoryTabData,
            payload.exportData[0].parent_Category,
            payload.exportData[0].parent_Subcategory,
            payload.exportData
          );
        } else if (payload.listName === 'Producer' || payload.listName === 'Brand') {
          const { exportedProducerTabData } = state;
          state.exportedProducerTabData = lastTabMethods(
            exportedProducerTabData,
            payload.exportData[0].parent_Producer,
            payload.exportData[0].parent_Brand,
            payload.exportData
          );
        }
        break;
      case 'resetSubTab':
        if (payload.listName === 'Category') {
          const { exportedCategoryTabData } = state;
          state.exportedCategoryTabData = resetSubTab(exportedCategoryTabData, payload.exportData[0].parent_Category);
        } else if (payload.listName === 'Producer' || payload.listName === 'Brand') {
          const { exportedProducerTabData } = state;
          state.exportedProducerTabData = resetSubTab(exportedProducerTabData, payload.exportData[0].parent_Producer);
        }
        break;
      case 'resetLastTab':
        if (payload.listName === 'Category') {
          const { exportedCategoryTabData } = state;
          state.exportedCategoryTabData = resetLastTab(
            exportedCategoryTabData,
            payload.exportData[0].parent_Category,
            payload.exportData[0].parent_Subcategory
          );
        } else if (payload.listName === 'Producer' || payload.listName === 'Brand') {
          const { exportedProducerTabData } = state;
          state.exportedProducerTabData = resetLastTab(
            exportedProducerTabData,
            payload.exportData[0].parent_Producer,
            payload.exportData[0].parent_Brand
          );
        }
        break;
      case 'updateRoot':
        if (payload.listName === 'Category') {
          const { exportedCategoryTabData } = state;

          state.exportedCategoryTabData = updateRootData(
            exportedCategoryTabData,
            payload.exportData
          );
        } else if (payload.listName === 'Producer' || payload.listName === 'Brand') {
          const { exportedProducerTabData } = state;

          state.exportedProducerTabData = updateRootData(
            exportedProducerTabData,
            payload.exportData
          );
        }
        break;
      default:
        state.exportedProducerTabData = [];
        state.exportedCategoryTabData = [];
    }
  }
};

export const actions = createCrudActions(types);

export default {
  state: SkuAvailabilityState,
  mutations,
  actions: {
    async fetchSkuAvailability({ commit, state }, { projectId, listType, params }) {
      commit(actions.index.request());

      try {
        const res = await fetchSkuAvailability(projectId, listType, params);
        const { meta } = res.data;
        const isSkuList = chain(res.data.data)
          .head()
          .get('key')
          .isSafeInteger()
          .value();

        const skuIDs = [];
        let list = res.data.data;
        let skuIDsGonnaFetch = [];
        let keepOldSkus = true;

        list.forEach((i) => {
          if (!skuIDs.includes(i.key)) skuIDs.push(i.key);
        });

        if (isSkuList) {
          if (state.projectID !== projectId || !state.allSkuList.length) {
            skuIDsGonnaFetch = skuIDs;
            keepOldSkus = false;
          } else {
            const unFetchedSkuIds = [];

            skuIDs.forEach((id) => {
              if (!state.allSkuList.some(sku => sku.id === id)) unFetchedSkuIds.push(id);
            });

            skuIDsGonnaFetch = unFetchedSkuIds;
          }

          if (skuIDsGonnaFetch.length) {
            const { data: { data } } = await fetchSkus(projectId, { search: { ids: skuIDsGonnaFetch.toString() }, per: 9999 });
            const allSkus = keepOldSkus ? [...state.allSkuList, ...data] : data;

            commit('updateSkuListTab', { allSkus, projectId });
          }

          list = list.map(item => ({
            ...item,
            sku: state.allSkuList.find(sku => sku.id === item.key)
          }));
        }

        commit(actions.index.success({ data: list, meta }));

        return Promise.resolve({ data: { data: list, meta } });
      } catch (error) {
        commit(actions.index.failure(error));

        return Promise.reject(error);
      }
    },
    exportDataTab({ commit }, {
      data, params, position, listName
    }) {
      if ((params.tags.Category && params.tag_type) || (params.tags.Producer && !params.tags.Brand)) {
        if (params.tags.Category) {
          const exportData = data.map(item => ({ parent_Category: params.tags.Category ? params.tags.Category[0] : null, ...item }));
          commit('updateExportedData', { exportData, position, listName });
        } else if (params.tags.Producer) {
          const exportData = data.map(item => ({ parent_Producer: params.tags.Producer ? params.tags.Producer[0] : null, ...item }));
          commit('updateExportedData', { exportData, position, listName });
        }
      } else if ((params.tags.Category && params.tags.Subcategory) || (params.tags.Category && params.tags['Detailed Category'][0]) || (params.tags.Producer && params.tags.Brand)) {
        if (params.tags.Category) {
          const exportData = data.map(item => (
            {
              parent_Category: params.tags.Category ? params.tags.Category[0] : null,
              parent_Subcategory: params.tags.Subcategory ? params.tags.Subcategory[0] : params.tags['Detailed Category'][0],
              ...item
            }
          ));

          commit('updateExportedData', { exportData, position, listName });
        } else if (params.tags.Producer) {
          const exportData = data.map(item => (
            {
              parent_Producer: params.tags.Producer ? params.tags.Producer[0] : null,
              parent_Brand: params.tags.Brand ? params.tags.Brand[0] : null,
              ...item
            }
          ));

          commit('updateExportedData', { exportData, position, listName });
        }
      } else {
        commit('updateExportedData', { exportData: data, position, listName });
      }
    }
  }
};
